module.exports = __webpack_public_path__ + "img/symbol_10.07f93284.png";